import {FreeWallMicrosite} from "./freewall.microsite";
import {schemaOf} from "@rezonence/schema-transformer";

export const micrositeSchema = schemaOf<FreeWallMicrosite>();
